// extracted by mini-css-extract-plugin
module.exports = {"mediaCarousel":"Media_mediaCarousel__2GFoA"};